"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainEventHandlerBase = void 0;
class DomainEventHandlerBase {
    constructor(config) {
        this.eventListenerMap = new Map();
        this.config = config;
    }
    findBindingByEvent(event) {
        const eventClassName = event.constructor['name'];
        const binding = this.config.bindings.find((i) => i.event == eventClassName);
        if (!binding) {
            throw new Error(`can't find binding: ${eventClassName}`);
        }
        return binding;
    }
    findBindingByTopic(topic) {
        const binding = this.config.bindings.find((i) => i.topic == topic);
        if (!binding) {
            throw new Error(`can't find binding: ${topic}`);
        }
        return binding;
    }
    getInboundBinders() {
        return this.config.bindings.filter((i) => i.inbound);
    }
    dispatchEvent(eventName, eventData) {
        const listeners = this.eventListenerMap.get(eventName) || [];
        for (const listener of listeners) {
            listener(eventData);
        }
    }
    subscribe(eventClassName, listener) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.eventListenerMap.has(eventClassName)) {
                this.eventListenerMap.set(eventClassName, []);
            }
            (_a = this.eventListenerMap.get(eventClassName)) === null || _a === void 0 ? void 0 : _a.push(listener);
        });
    }
}
exports.DomainEventHandlerBase = DomainEventHandlerBase;
